module.exports = __webpack_public_path__ + "img/header-weddingRingsSignature.2d7cea6.webp";